<template>
  <div>
    <input v-for="(id, removedIndex) in removedIds" :key="removedIndex" type="hidden" :name="removedName+'[]'" :value="id">
    <table class="w-100">
      <thead>
        <tr>
          <th>&nbsp;</th>
          <th v-for="(column, index) in columns" :key="index" class="p-1">
            {{__(column)}}
          </th>
        </tr>
      </thead>
      <draggable :value="elements" tag="tbody" handle=".draggable-handle" @update="handleMove">
        <tr v-for="(element, index) in elements" :key="index">
          <td class="p-1 draggable-handle" style="width: 24px; font-size: 22px; cursor: move;">
            <i class="fa fa-bars"></i>
            <input type="hidden" :name="idName+'[]'" :value="element[idName]">
            <input type="hidden" :name="orderName+'[]'" :value="index">
          </td>
          <td v-for="column in columns" :key="index" class="p-1">
            <input type="text" class="form-control" :name="column+'[]'" v-model="element[column]" @keydown.down="focusIndex(index+1)" @keydown.enter="focusIndex(index+1)" @keydown.up="focusIndex(index-1)">
          </td>
          <td class="p-1" style="width: 1%;">
            <button class="btn red" type="button" @click="removeElement(index)"> <i class="fa fa-times"></i> </button>
          </td>
        </tr>
        <tr>
          <td class="p-1" style="width: 24px;">&nbsp;</td>
          <td class="p-1">
            <button class="btn blue w-100" style="display: block" type="button" @click="addElement"> Ajouter </button>
          </td>
        </tr>
      </draggable>
    </table>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  name: "simple-listing",
  components: {
    draggable,
  },
  props: {
    fields: {
      type: String,
      required: true
    },
    idName: {
      type: String,
      required: true
    },
    orderName: {
      type: String,
      required: true
    },
    removedName: {
      type: String,
      required: true
    },
    values: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      elements: this.values,
      removedIds: []
    }
  },
  computed: {
    columns() {
      return this.fields.split(","); 
    }
  },
  mounted () {
    if(this.elements.length == 0){
      this.addElement();
    }
  },
  methods: {
    addElement() {
      let element = {};
      for (const column of this.columns) {
        element[column] = "";
      }
      element.id = null;
      this.elements.push(element);
    },
    removeElement(index) {
      let element = this.elements[index];
      let id = element[this.idName];
      if(id != null){
        this.removedIds.push(id);
      }
      this.elements.splice(index, 1);
    },
    handleMove(ev) {
      this.elements.move(ev.oldIndex, ev.newIndex)
    },
    focusIndex(index) {
      let field = this.columns[0];
      let selector = `input[name='${field}[]']`;

      if(index < 0){
        index = 0;
      } else if(index >= this.elements.length){
        this.addElement();
      }

      setTimeout(() => {
        $(selector).get(index).select();
      }, 10);
    }
  },
}
</script>

<style lang="scss" scoped>

</style>